<template>
  <v-card class="pa-2" max-width="374">
    <v-sheet>
      <v-card-title>Investigation Details</v-card-title>

      <v-card-text>
        <div class="my-4 text-h4 text-center  green--text">
            {{time}} hours
        </div>

        <div class="text-center mt-n4">
          Average Reponse Time
        </div>
      </v-card-text> 
    </v-sheet>

    <v-divider class="mt-5"></v-divider>

    <v-card-text class="mt-3">
      <v-list-item class="grow ml-n5">
        <v-icon class="mr-1">
          mdi-calendar-month
        </v-icon>
        <span class="subheading mr-2">Date Period</span>
        <v-row align="center" justify="end">
          <span class="subheading">{{ datePeriod }}</span>
        </v-row>
      </v-list-item>
      <v-list-item class="grow ml-n5">
        <v-icon class="mr-1">
          mdi-finance
        </v-icon>
        <span class="subheading mr-2">Status</span>
        <v-row align="center" justify="end">
          <span class="subheading">{{
            closeOut ? "Close Out" : "Active"
          }}</span>
        </v-row>
      </v-list-item>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import axios from 'axios'
import { mapGetters } from "vuex";
import { setUserTz, tz } from "../../../utils/timezone";

const url = require("../../client_config/config").url;

export default {
  props: {
    investigationItemData: {
      type: Array,
      default: () => [],
    },
    date: {
      type: Array,
      default: () => [],
    },
    responseTimeAvg: {
      type: String,
    },
    investigationID: {
      type: String
    },
    closeOut: {
      type: Boolean,
    },

  },

  data: function() {
    return {
      investigations: [],
      time: "",
      average: 0,
      divider: 0,
    }
  },

  computed: {
    ...mapGetters("timezones", ["getUserTimezone", "getDefaultTz"]),

    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },

    investigationSideData() {
      const filterInvestigations = this.investigationItemData.find(
        (item) => item._id === this.investigationID
      )
      console.log(this.investigationItemData)
      return {
        ResponseTime: filterInvestigations?.ResponseDate
      }
    },

    datePeriod() {
      let investigationDates = this.$store.state.investigations.items.map(
        (item) => item.ResponseDate
      );

      let earliestDate = this.getMinDate(investigationDates);
      let latestDate = this.getMaxDate(investigationDates);
      let datePeriod = "";

      if ((earliestDate && latestDate) == "Invalid Date") {
        return null;
      }

      if (Date.parse(earliestDate) == Date.parse(latestDate)) {
        return (datePeriod = `${tz(earliestDate, this.userTimezone).format(
          "DD MMM"
        )} - Present`);
      }

      datePeriod = `${tz(earliestDate, this.userTimezone).format(
        "DD MMM"
      )} - ${tz(latestDate, this.userTimezone).format("DD MMM")}`;

      return datePeriod;
    },

    // responseTime(){
    //   let responseTime = this.$store.state.investigations.items.map(
    //     (item) => item.ResponseDate 
    //   );

    //   return responseTime
    // }
  },

  created() {
    this.getInvestigations()
  },

  methods: {
    getMaxDate(dates) {
      let moments = dates.map((x) => moment(x)),
        maxDate = moment.max(moments).format("YYYY-MM-DD");
      return maxDate;
    },
    getMinDate(dates) {
      let moments = dates.map((x) => moment(x)),
        maxDate = moment.min(moments).format("YYYY-MM-DD");
      return maxDate;
    },

    getInvestigations() {
      this.divider = 0;
      this.average = 0;
      axios.get(`${url}/investigationLogs/${this.investigationID}`).then(res => {
        this.investigations = res.data.investigationLogs
        for(var i = 0; i < this.investigations.length; i++){
          const difference = moment(this.investigations[i].ReponseDate).diff(moment(this.investigations[i].ResponseDate))
          const diff = moment.duration(difference).asHours().toFixed(2);
          this.average += parseFloat(diff)
          this.divider += 1
          this.time = parseFloat(this.average) / parseInt(this.divider)
        }
      })
    }

  },
};
</script>
